/**
 * @class
 */
import Base from './attribute';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';
import {assetExpirationToDateString} from '@netx/core-asset-expiration/utils';

export default class Attribute_Date extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.date,
		};
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @param {number} truncateAt Truncate at index
	 * @return {mixed} Formatted value
	 */
	format(value, truncateAt) {
		// In all cases (currently), except one, we want `yyyy-mm-dd`
		// The dam will sometimes send us mm/dd/yyyy and we want to normalize this
		// except for `expirationDate` - which is a time and a time that we want to
		// show in a relative format
		if (this.get('system') && this.get('name') === 'expirationDate') {
			if (value) {
				value = `${i18n.t('i18n.expires')}: ${assetExpirationToDateString(
					value,
				)}`;
			}
			return value === 0 ? '' : value;
		}

		value = this.parseInValue(value);
		return super.format(value);
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @return {mixed} Parsed in value
	 */
	parseInValue(value) {
		value = super.parseInValue(value);

		if (_.isArray(value)) {
			value = _.map(value, (v) => {
				if (v.includes('/')) {
					v = _.dateToHTML(v);
				}
				return v;
			});
		} else if (value && (_.isNumber(value) || value.includes('/'))) {
			value = _.dateToHTML(value);
		}

		return value;
	}

	/**
	 * @override
	 * @param {mixed} value Value
	 * @return {mixed} Parsed out value
	 */
	parseOutValue(value) {
		value = super.parseOutValue(value);

		if (_.isArray(value)) {
			value = _.map(value, (d) => {
				if (_.isNumber(d)) {
					return d;
				}
				return d.replace(/(\d+)-(\d+)-(\d+)/, '$2/$3/$1');
			});
		} else if (value) {
			value = _.isNumber(value)
				? value
				: value.replace(/(\d+)-(\d+)-(\d+)/, '$2/$3/$1');
		}

		// Ensure leading zero's or server side validation will fail
		if (_.isString(value) && value.length) {
			value = value
				.split('/')
				.map((v) => {
					return v.padStart(2, '0');
				})
				.join('/');
		}
		return value;
	}

	/** @method */
	validator(val) {
		if (val === '' || val == null) return true;

		const valid =
			val.search(/\d\d\/\d\d\/\d\d\d\d/) > -1 ||
			val.search(/\d\d\d\d-\d\d-\d\d/) > -1;

		if (!valid) return new Error('Invalid date');
		return true;
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Date';
	}
}
